/* eslint-disable no-param-reassign */
import Vue from 'vue';
import { pick } from "lodash-es";
import ArrayTable from '.';
import ColsEditorComponent from './ColsEditor';
import { DEFAULT_EDITORS_FIT_DATA_ORDER } from "../../../../lib/utils/consts";
import getDefaultColumns, { wrapAsCellScopedSlot } from './getDefaultColumns';

/** @type {UICore.ComponentMeta} */
const ArrayTableComponentMeta = {
  id: 'arrayTable',
  name: '表格列表',
  visible: false,
  component: ArrayTable,
  isFormEditor: true,
  slots: ({
    props
  }) => {
    var _props$cols;
    return [...(((_props$cols = props.cols) === null || _props$cols === void 0 ? void 0 : _props$cols.map(col => ({
      id: `col-${col.id}`,
      type: 'scoped',
      default: wrapAsCellScopedSlot({
        type: 'w-text',
        props: {
          text: '请编辑此单元格'
        }
      })
    }))) || []), {
      id: 'empty',
      containerRef: 'emptySlot'
    }];
  },
  bindings: [{
    id: '数据源',
    pathProp: 'path',
    required: true,
    main: true,
    checkData: s => s.type === 'array'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'path',
      type: 'string',
      title: '数据源'
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读'
    }, {
      id: 'disableAdd',
      title: '禁止新增',
      type: 'boolean'
    }, {
      id: 'disableDelete',
      title: '禁止删除',
      type: 'boolean'
    }, {
      id: 'confirmBeforeDelete',
      title: '删除前需要确认',
      type: 'boolean',
      condition: '!props.disableDelete'
    }, {
      id: 'hideNumber',
      title: '隐藏序号',
      type: 'boolean',
      default: true
    }, {
      id: 'disableDrag',
      title: '禁止拖拽序号以调整顺序',
      type: 'boolean',
      condition: '!props.hideNumber'
    }, {
      id: 'cols',
      type: 'array',
      title: '表格列',
      ui: {
        type: 'colsEditor'
      },
      'uc:allowInterop': true,
      'uc:allowExpr': false,
      items: {
        type: 'object',
        fields: [{
          id: 'id',
          type: 'string',
          required: true
        }, {
          id: 'title',
          type: 'string'
        }, {
          id: 'description',
          type: 'string'
        }, {
          id: 'width',
          type: 'string'
        }
        // { id: "readonly", type: "boolean" },     // data-schema 历史遗留
        ]
      }
    }, {
      id: 'maxLength',
      title: '条数上限',
      type: 'integer',
      default: 0,
      description: '在允许新增的情况下，如果列表内超出这个数量，就禁止新增条目。 0 表示无限制'
    }, {
      id: 'minLength',
      title: '条数下限',
      type: 'integer',
      default: 0,
      description: '校验数据时使用'
    }, {
      id: 'keyingRule',
      title: '列表项的key',
      description: '相当于 v-for 里的 key 的计算方式',
      type: 'any',
      group: '高级配置',
      ui: {
        type: 'listKeyingRuleInput'
      }
    }]
  },
  events: [{
    id: 'delete',
    name: '删除单条',
    desc: '删除单条前触发，可通过 终止流程 的方式阻止删除。可使用 `$event` 获取要删除的项',
    arguments: [{
      type: 'object',
      description: '要删除的东西是什么？',
      fields: [{
        id: 'index',
        type: 'number',
        description: '删除的序号（从0开始）'
      }, {
        id: 'item',
        type: 'any',
        description: '数据项'
      }, {
        id: 'list',
        type: 'array',
        description: '整个数据数组'
      }]
    }],
    asProp: 'handleDelete'
  }],
  propPanel: {
    colsEditor: {
      id: 'colsEditor',
      component: ColsEditorComponent
    }
  },
  getActions({
    instance,
    uc,
    modifyComp
  }) {
    return [{
      title: '编辑“没有内容”状态',
      icon: 'fa fa-edit',
      highlighted: !!(instance !== null && instance !== void 0 && instance.emulateEmptyMode),
      execute() {
        instance.emulateEmptyMode = !instance.emulateEmptyMode;
      }
    }, instance !== null && instance !== void 0 && instance.path ? {
      title: '重置表格列',
      icon: 'fa fa-magic',
      place: ['propPanel'],
      async execute() {
        await modifyComp(c => {
          const ans = getDefaultColumns({
            uc,
            dataStub: instance.arrayStub
          });
          if (!ans) return;
          const {
            cols,
            scopedSlots
          } = ans;
          Vue.set(c, 'props', {
            ...c.props,
            cols
          });
          Vue.set(c, 'scopedSlots', {
            ...pick(c.scopedSlots, ['footer', 'empty']),
            ...scopedSlots
          });
        });
      }
    } : null];
  },
  fitData({
    uc,
    dataStub,
    dataPath
  }) {
    if (dataStub.type !== 'array') return null;
    const ans = getDefaultColumns({
      uc,
      dataStub
    });
    if (!ans) return;
    const {
      cols,
      scopedSlots
    } = ans;
    return {
      type: 'editor',
      order: DEFAULT_EDITORS_FIT_DATA_ORDER,
      layout: {
        type: 'arrayTable',
        bindings: {
          数据源: dataPath
        },
        props: {
          cols
        },
        scopedSlots
      }
    };
  }
};
export default ArrayTableComponentMeta;